import ErrorOutlinedIcon from '@mui/icons-material/ErrorOutlined';
import { Avatar, ListItem, ListItemText, TableCell, TableContainer, TableRow } from '@mui/material';
import styled from 'styled-components';
import { colors, fontFamilyPrimary, fontWeight, fontSize } from '../../theme';
import { ActionButtonStyled } from '../Modals/DashboardModal/DashboardModalContent/styled';

export const ContainerTenantStyled = styled.div`
    display: grid;
    gap: 24px;
    grid-template-columns: repeat(4, 1fr);
`;

export const ListIconStyled = styled(Avatar)`
    && {
        pointer-events: none;
        border-radius: 4px;
        background-color: ${colors.grey700};
        color: ${colors.greyDisabled};
        margin-right: 8px;
        width: 32px;
        height: 32px;
        box-sizing: border-box;
        svg {
            width: 16px;
            padding: 8px;
        }
        ${({ $hasHoverProp } : { $hasHoverProp: boolean }) => $hasHoverProp
            && `
                pointer-events: auto;
                background-color: ${colors.default};
                color: white;
                cursor: pointer;
                &:hover {
                    background: ${colors.defaultDarker};
                    color:white;
                }`
}
    }
`;

export const ListItemTextStyled = styled(ListItemText)`
    && {
        span {
            font-family: ${fontFamilyPrimary};
            color: ${colors.grey200};
            font-weight: ${fontWeight.semiRegular};
            line-height: 20px;
        }
    }
`;

export const ListItemStyled = styled(ListItem)`
    && {
        padding-bottom: 8px;
        padding-left: 0;
        padding-right: 0;
    }

`;

export const AddDiffusionListContainerStyled = styled.div`
    border: 1px dashed ${colors.default};
    border-radius: 8px;
    padding: 32px;
    box-sizing: border-box;
    margin: 60px auto;
    width: 60%;
    display: flex;
    align-items: center;
    flex-direction: column;
    text-align: center;
    max-width: 610px;
`;

export const ErrorOutlinedIconStyled = styled(ErrorOutlinedIcon)`
    && {
        color: ${colors.grey500};
        font-size: 32px;
    }
`;

export const ActionSurveyButtonStyled = styled(ActionButtonStyled)`
    && {
        box-shadow: ${colors.defaultShadow};
    }
`;

export const TableRowStyled = styled(TableRow)`
    &&.MuiTableRow-root:nth-child(odd)   {
        background: transparent;
    }
`;
export const TableCellBody = styled(TableCell)`
    && {
        font-family: ${fontFamilyPrimary};
        color: ${colors.grey200};
        font-weight: ${fontWeight.semiRegular};
        font-size: ${fontSize.m};
        padding: 9px 0;
        border-bottom: none;
        &&.MuiTableCell-root {
            line-height: 9px;
        }
    }
`;
export const TableCellHead = styled(TableCell)`
    && {
        color: ${colors.grey100};
        font-weight: ${fontWeight.semiBold};
        font-family: ${fontFamilyPrimary};
        font-size: ${fontSize.m};
        border-bottom: none;
        padding: 9px 0;

    }
`;
export const TableCellSpecialBody = styled.p(({ disabled }: {disabled: boolean}) => `
    && {
        background-color: ${disabled ? colors.grey600 : colors.alertSuccess};
        display: inline;
        padding: 4px;
        border-radius: 4px;
        font-size: ${fontSize.sm};
        font-weight: ${fontWeight.regular};
        color: ${disabled ? colors.grey200 : colors.grey000};
    }
`);

export const TableContainerStyled = styled(TableContainer)`
    margin-top: 28px;
`;

export const EmptyMailingListTitle = styled.div`
    margin-top: 34px;
`;

export const HeaderTenantsListStyled = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: baseline;

`;

export const TenantsListActionsHeaderStyled = styled.div`
    display: flex;
    gap: 16px;
    margin-top: 34px;
`;
